import _extends from "@babel/runtime/helpers/esm/extends";
import useCount from './useCount';
import useCountFromContentRange from './useCountFromContentRange';
import useCreateMany from './useCreateMany';
import useCreateOne from './useCreateOne';
import useFetchMutationById from './useFetchMutationById';
import useFindById from './useFindById';
import useFindByIds from './useFindByIds';
import useFindMany from './useFindMany';
import useFindOne from './useFindOne';
import usePagination from './usePagination';
import usePatchOne from './usePatchOne';
import useRemoveById from './useRemoveById';
import useUpdateOne from './useUpdateOne';
const createCrud = basePath => ({
  // count
  makeCount: (variant = 'v2/{basePath}') => (params, options) => useCount(variant, basePath, params, options),
  // countFromContentRange
  makeCountFromContentRange: (variant = 'v2/{basePath}') => (params, options) => useCountFromContentRange(variant, basePath, params, options),
  // findById
  makeFindById: (variant = 'v2/{basePath}/{id}') => (params, options) => useFindById(variant, basePath, params, options),
  // findByIds
  makeFindByIds: (variant = 'v2/{basePath}') => (params, options) => useFindByIds(variant, basePath, params, options),
  // findMany
  makeFindMany: (variant = 'v2/{basePath}') => (params, options) => useFindMany(variant, basePath, params, options),
  // findOne
  makeFindOne: (variant = 'v2/{basePath}') => (params, options) => useFindOne(variant, basePath, _extends({}, params, {
    limit: 1
  }), options),
  // pagination
  makePagination: (variant = 'v2/{basePath}') => (params, options) => usePagination(variant, basePath, params, options),
  // createOne
  makeCreateOne: (variant = 'v2/{basePath}') => options => useCreateOne(variant, basePath, options),
  // createOne
  makeCreateMany: variant => options => useCreateMany(variant, basePath, options),
  // patchOne
  makePatchOne: (variant = 'v2/{basePath}/{id}') => options => usePatchOne(variant, basePath, options),
  // updateOne
  makeUpdateOne: (variant = 'v2/{basePath}/{id}') => options => useUpdateOne(variant, basePath, options),
  // removeById
  makeRemoveById: (variant = 'v2/{basePath}/{id}') => options => useRemoveById(variant, basePath, options),
  // fetchMutationById
  makeFetchMutationById: (variant = 'v2/{basePath}/{id}') => options => useFetchMutationById(variant, basePath, options)
});
export default createCrud;